import InputField from "@/components/Common/forms/InputField";
import useRegistrationStore, {type TRegistrationState} from "@/store/registration";
import {type FC, type HTMLInputTypeAttribute, type ReactNode, memo} from "react";
import {useTranslation} from "react-i18next";

const RegistrationInputField: FC<{
  onChange?: (value: string) => void;
  storeKey: keyof TRegistrationState["errors"];
  icon?: ReactNode;
  type?: HTMLInputTypeAttribute;
  label?: string;
  value?: string | null;
  placeholder?: string;
  className?: string;
  name?: string;
  disabled?: boolean;
  optional?: boolean;
}> = ({
  onChange,
  storeKey,
  icon = null,
  label,
  placeholder,
  type = "text",
  value,
  className,
  name,
  disabled = false,
  optional,
}) => {
  const {t} = useTranslation();
  const errorMessage = useRegistrationStore(state => state.errors[storeKey]);
  const setValue = useRegistrationStore(state => state.setValue);
  const valueFromStore = useRegistrationStore(state => state[storeKey]);

  return (
    <InputField
      onChange={value => (onChange ? onChange(value) : setValue(storeKey, value))}
      className={className}
      icon={icon}
      label={label}
      placeholder={placeholder}
      type={type}
      value={value ?? valueFromStore}
      error={t(errorMessage)}
      name={name ?? storeKey}
      isDisabled={disabled}
      optional={optional}
    />
  );
};

export default memo(RegistrationInputField);
